import { NavLink } from "react-router";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import { useTranslation } from "react-i18next";
import apiIcon from "../../assets/icons/api.png";
import cargoIcon from "../../assets/icons/cargo.png";
import helpIcon from "../../assets/icons/help.png";
import mailingIcon from "../../assets/icons/mailing.png";
import profileIcon from "../../assets/icons/profile.png";
import userStatsIcon from "../../assets/icons/user-stats.png";

const UserMenu = () => {
	const { t } = useTranslation();

	return (
		<List>
			<ListItem disablePadding>
				<NavLink
					to={`/`}
					className={({ isActive, isPending }) =>
						isActive ? "active" : isPending ? "pending" : ""
					}
				>
					<Tooltip
						title={
							<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
								{t("menu_cargos")}
							</Typography>
						}
						placement="right"
					>
						<ListItemButton>
							<img id="side-menu-cargos" src={cargoIcon} alt="" />
						</ListItemButton>
					</Tooltip>
				</NavLink>
			</ListItem>
			<ListItem disablePadding>
				<NavLink
					to={`/stats`}
					className={({ isActive, isPending }) =>
						isActive ? "active" : isPending ? "pending" : ""
					}
				>
					<Tooltip
						title={
							<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
								{t("menu_my_stats")}
							</Typography>
						}
						placement="right"
					>
						<ListItemButton>
							<img id="side-menu-user-stats" src={userStatsIcon} alt="" />
						</ListItemButton>
					</Tooltip>
				</NavLink>
			</ListItem>
			<ListItem disablePadding>
				<NavLink
					to={`/recipients`}
					className={({ isActive, isPending }) =>
						isActive ? "active" : isPending ? "pending" : ""
					}
				>
					<Tooltip
						title={
							<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
								{t("menu_mailing_groups")}
							</Typography>
						}
						placement="right"
					>
						<ListItemButton>
							<img id="side-menu-recipients" src={mailingIcon} alt="" />
						</ListItemButton>
					</Tooltip>
				</NavLink>
			</ListItem>
			<ListItem disablePadding>
				<NavLink
					to={`/user-data`}
					className={({ isActive, isPending }) =>
						isActive ? "active" : isPending ? "pending" : ""
					}
				>
					<Tooltip
						title={
							<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
								{t("menu_my_account")}
							</Typography>
						}
						placement="right"
					>
						<ListItemButton>
							<img src={profileIcon} alt="" />
						</ListItemButton>
					</Tooltip>
				</NavLink>
			</ListItem>
			<ListItem disablePadding>
				<NavLink
					to={`/integrations`}
					className={({ isActive, isPending }) =>
						isActive ? "active" : isPending ? "pending" : ""
					}
				>
					<Tooltip
						title={
							<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
								{t("menu_integrations")}
							</Typography>
						}
						placement="right"
					>
						<ListItemButton>
							<img id="side-menu-api" src={apiIcon} alt="" />
						</ListItemButton>
					</Tooltip>
				</NavLink>
			</ListItem>
			<ListItem disablePadding>
				<a
					href="https://cargoseller.pl/wp-content/uploads/2025/01/CARGOseller-szybki-start-objasnienie.pdf"
					target="_blank"
					rel="noreferrer"
				>
					<Tooltip
						title={
							<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
								{t("menu_system_guide")}
							</Typography>
						}
						placement="right"
					>
						<ListItemButton>
							<img
								src={helpIcon}
								style={{
									filter: "invert(1)",
								}}
								alt=""
							/>
						</ListItemButton>
					</Tooltip>
				</a>
			</ListItem>
		</List>
	);
};

export default UserMenu;
